var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 20",
    style: {
      enableBackground: "new 0 0 30 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#98A2BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(0 -92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    transform: "translate(0 92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    className: "st0",
    d: "M25.19,9.52c-0.18-0.25-4.54-6.13-10.11-6.13S5.15,9.26,4.97,9.52c-0.17,0.24-0.17,0.56,0,0.8 c0.18,0.25,4.54,6.13,10.11,6.13s9.93-5.88,10.11-6.13C25.37,10.08,25.38,9.75,25.19,9.52z M15.08,15.09 c-4.1,0-7.65-3.9-8.7-5.18c1.05-1.28,4.6-5.18,8.7-5.18s7.65,3.9,8.7,5.18C22.74,11.19,19.19,15.09,15.08,15.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    transform: "translate(6.189 95.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    className: "st0",
    d: "M8.89,3.39c-2.24,0-4.05,1.81-4.05,4.05c0,2.24,1.81,4.05,4.05,4.05 c2.24,0,4.05-1.81,4.05-4.05c0,0,0,0,0,0C12.94,5.2,11.13,3.39,8.89,3.39z M8.89,10.14c-1.49,0-2.7-1.21-2.7-2.7 c0-1.49,1.21-2.7,2.7-2.7c1.49,0,2.7,1.21,2.7,2.7l0,0C11.59,8.93,10.38,10.14,8.89,10.14z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptEye);
export default __webpack_public_path__ + "static/media/recrypt_eye.ecb770ce.svg";
export { ForwardRef as ReactComponent };